import { exit_stream, fetchResponses, checkItemExists, updateMetaTags, loadReveal } from "../script.js";
import { useEffect } from 'react';
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import KindleSlides from "../Util/KindleSlides.js";

export default function Dentists() {
  const navigate = useNavigate();
  let userInputField;
  let loadingIndicator;
  let spinnerOverlay;

  useEffect(() => {
    userInputField = document.getElementById('user-input');
    loadingIndicator = document.getElementById('loading');
    spinnerOverlay = document.getElementById('spinner-overlay');

    // Handle button click
    document.getElementById('btn-query').addEventListener('click', handleUserInput);

    // Handle Enter key press
    userInputField.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        handleUserInput(event);
      }
    });

    if (queryParam) {
      document.title = `6 Hats - ${decodeURIComponent(queryParam)}`;
      userInputField.value = decodeURIComponent(queryParam);
      userInputField.classList.add('loading');
      loadingIndicator.style.display = 'inline';
      loadingIndicator.style.margin = 'auto';
      spinnerOverlay.style.display = 'inline';
      spinnerOverlay.style.margin = 'auto';
      fetchResponses(queryParam, loadingIndicator, spinnerOverlay, userInputField, navigate);
    }
    const arrowButton = document.querySelector(".arrow-button");
    updateMetaTags();
    
  }, []);

  let response_1 = "Patients will ask AI and Google for answers, no matter what. They're looking for advice on tooth pain, whitening, braces, and implants—and the internet will provide. The question is, will it be the right answer? Will it lead them to you?";
  let response_2 = "6hats public stream lets dentists comment on AI answers, building credibility and creating a searchable resource that attracts new patients seeking trusted care.";
  let response_3 = "Patient retention and engagement are critical in a competitive dental market, where maintaining trust and satisfaction is key to ensuring long-term loyalty.";
  let response_4 = "By allowing dentists to upload documents and using AI to answer patient questions accurately with Composite Vector Database Technology, 6Hats private streams reduce repetitive tasks, freeing dentists to focus on more critical aspects of patient care.";
  let response_5 = "In a competitive market, dentists face the challenge of keeping patients engaged and satisfied beyond routine appointments, leading to higher patient churn.";
  let response_6 = "6hats Public stream helps retain patients by offering ongoing, interactive communication through expert-backed, AI-generated responses. This constant engagement fosters trust and satisfaction, ensuring patients stay connected to your practice.";

  let about_6hats = [
    `How to Stand Out from 1000s of Dentists?: ${response_1}`,
    `Attracting New Patients with 6hats Streams: ${response_2}`,
    `Patient Retention in a Competitive Market: ${response_3}`,
    `Eliminate Inefficient Patient Communication and Administrative Burden: ${response_4}`,
    `Retention Problem - Maintaining Long-Term Relationships: ${response_5}`,
    `6hats Public Stream for Retention: ${response_6}`,
  ]

  const handleUserInput = async function (event) {
    event.preventDefault();
    const userInput = userInputField.value.trim();
    const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
    /*global uuid*/
    const guid = uuid.v5(userInput, NAMESPACE_URL);

    if (userInput !== '') {
      spinnerOverlay.style.display = 'flex';
      const encodedQuery = encodeURIComponent(userInput);
      const responseSlidesPresent = document.getElementById('response-slides').childElementCount > 0;

      if (responseSlidesPresent) {
        await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
      } else {
        const itemExists = await checkItemExists(guid);
        if (itemExists) {
          navigate(`/?item=${guid}`, { replace: true });
        } else {
          await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
        }
      }
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  const queryParam = urlParams.get('query');

  return (
    <>
      <div className="content-div">
        {about_6hats.length > 0 ?
          <KindleSlides slides={about_6hats} /> : null
        }

        {/* Text box container fixed at the bottom of the page*/}
        <div className="textbox-container">
          <textarea id="user-input" rows="2" placeholder="6Hats – AI answers. You save. Experts bring nuance."></textarea>
          {/* Upward arrow button on the right side */}
          <button className="arrow-button" id="btn-query">
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>

        {/* TODO Show during loading */}
        <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

        {/* Spinner overlay */}
        <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
          <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
        </div>
      </div>
    </>
  );
}